var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Order } from '../../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var PropagateChangeIdBehavior = (function () {
    function PropagateChangeIdBehavior() {
    }
    PropagateChangeIdBehavior.prototype.apply = function (model, root) {
        if (!model.isRoot()) {
            var parent_1 = root.getParentByModel(model);
            parent_1.__subscribe(model);
        }
    };
    Object.defineProperty(PropagateChangeIdBehavior.prototype, "Order", {
        get: function () {
            return Order.ORD;
        },
        enumerable: false,
        configurable: true
    });
    PropagateChangeIdBehavior = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], PropagateChangeIdBehavior);
    return PropagateChangeIdBehavior;
}());
export { PropagateChangeIdBehavior };
